module.exports = __webpack_public_path__ + "e26648bb750595e0939694aa649f4141.svg";